import React from 'react';
import moment from 'moment';
import { Input, Tooltip, Select, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

const FormItem = Form.Item;
const Option = Select.Option;

export default ({ licencia }) => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  if (!licencia) {
    console.log('return null');
    return null;
  }

  return (
    <div>
      <Form style={{ marginTop: 50, marginRight: 40 }}>
        <FormItem
          {...formItemLayout}
          label={
            <span>
              Lugar
              <Tooltip title="Seleccione el organismo">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Select
            showSearch
            style={{ width: 500, color: '#000000' }}
            placeholder="Seleccione un organismo"
            optionFilterProp="children"
            disabled={true}
            defaultValue={licencia.organismo._id}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option key={licencia.organismo._id} value={licencia.organismo._id}>
              {licencia.organismo.nombre}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Empleado solicitante
              <Tooltip title="Solicitante">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Select
            showSearch
            style={{ width: 500, color: '#000000' }}
            placeholder="Usuario Solicitante"
            optionFilterProp="children"
            disabled={true}
            defaultValue={licencia.solicitante._id}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option
              key={licencia.solicitante._id}
              value={licencia.solicitante._id}
            >
              {licencia.solicitante.nombre +
                ' ' +
                licencia.solicitante.apellido}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Superior
              <Tooltip title="Superior que concede">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Select
            showSearch
            style={{ width: 500, color: '#000000' }}
            placeholder="Supervisor a ser notificado"
            optionFilterProp="children"
            disabled={true}
            defaultValue={licencia.superior._id}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option key={licencia.superior._id} value={licencia.superior._id}>
              {licencia.superior.nombre + ' ' + licencia.superior.apellido}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Fecha Inicio
              <Tooltip title="Fecha de inicio ">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <DatePicker
            format="DD-MM-YYYY"
            placeholder="Seleccionar Fecha"
            style={{ color: '#000000' }}
            defaultValue={moment(licencia.fechaInicio)}
            disabled={true}
          />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Fecha Fin
              <Tooltip title="Fecha de fin ">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <DatePicker
            format="DD-MM-YYYY"
            placeholder="Seleccionar Fecha"
            style={{ color: '#000000' }}
            defaultValue={moment(licencia.fechaFin)}
            disabled={true}
          />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Motivo
              <Tooltip title="Motivo de la licencia ">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Input
            readOnly={true}
            value={licencia.motivo}
            style={{ width: 500, color: '#000000' }}
          />
        </FormItem>
      </Form>
    </div>
  );
};
